module.exports = __webpack_public_path__ + "img/icon_user.7e7125cc.svg";